<template>
  <div>
    <h4>Messages</h4>
    <ul v-for="message in messages" v-bind:key="message">
      <li>{{ message }}</li>
    </ul>
  </div>
</template>
<script>
export default {
  data() {
    return {
      messages: ["hello", "hi", "its working"],
    };
  },
};
</script>